import {compressMeshForMobileDevices} from "../../../../../../helpers/sqft3dArSceneHelper";

class HandlesLoader {
  constructor(scene, loader) {
    this.scene = scene;
    this.loader = loader;
    this.handleCache = new Map();
  }

  async loadHandles(cabinetData, cabinetScene) {
    const drawerObjects = [];
    const doorObjects = [];

    cabinetScene.traverse((object) => {
      if (object.name && object.name.includes("Drawer_")) {
        drawerObjects.push(object);
      } else if (object.name && object.name.includes("Door_")) {
        doorObjects.push(object);
      }
    });

    if (drawerObjects.length === 0 && doorObjects.length === 0) {
      this.logMeshes();
      console.log(`Handles position not found in the scene`);
      return;
    }

    for (const handleIndex in cabinetData.handles) {
      if (!cabinetData.handles.hasOwnProperty(handleIndex)) continue;

      const handle = cabinetData.handles[handleIndex];

      // DRAWERS will use the same vertical handles model but rotated
      if (handle.handleH3dURL && drawerObjects.length > 0) {
        await this.loadAndApplyHandle(handle.handleH3dURL, drawerObjects, "H");
      }

      // Doors
      if (handle.handleV3dURL && doorObjects.length > 0) {
        await this.loadAndApplyHandle(handle.handleV3dURL, doorObjects, "V");
      }
    }
  }

  async loadAndApplyHandle(handleURL, targetObjects, orientationTag) {
    const cacheKey = `${handleURL}::${orientationTag}`;

    if (this.handleCache.has(cacheKey)) {
      const cachedHandle = this.handleCache.get(cacheKey);
      this.applyHandleToObjects(cachedHandle, targetObjects);
    } else {
      const gltfHandle = await this.loadHandle(handleURL, orientationTag);
      if (gltfHandle) {
        this.handleCache.set(cacheKey, gltfHandle);
        this.applyHandleToObjects(gltfHandle, targetObjects);
      }
    }
  }

  async loadHandle(handle3dURL, orientationTag) {
    return new Promise((resolve, reject) => {
      this.loader.load(handle3dURL, (gltfHandle) => {
        if (!gltfHandle || !gltfHandle.scene) {
          console.error(`GLTF scene not found for URL ${handle3dURL}`);
          reject(new Error("GLTF scene not found"));
          return;
        }

        let handleMesh = null;
        gltfHandle.scene.traverse((child) => {
          if (child.isMesh && child.name.includes(`_${orientationTag}_`)) {
            handleMesh = child.clone();
            compressMeshForMobileDevices(handleMesh);
          }
        });

        if (handleMesh) {
          resolve(handleMesh);
        } else {
          reject(new Error(`No matching mesh found with tag _${orientationTag}_ in GLTF`));
        }
      }, undefined, (error) => {
        console.error(`Error loading handle from URL ${handle3dURL}:`, error);
        reject(error);
      });
    });
  }


  applyHandleToObjects(handleMesh, targetObjects, rotate) {
    for (const obj of targetObjects) {
      this.applyHandleAsChild(handleMesh, obj, rotate);
    }
  }

  applyHandleAsChild(handleMesh, objectPlacement, rotate = false) {
    const handleClone = handleMesh.clone();

    if (rotate) {
      handleClone.rotation.z += Math.PI / 2; // Rotate 90 degrees
    }

    objectPlacement.add(handleClone);
  }

  logMeshes() {
    const allAssets = [];
    this.scene.traverse((object) => {
      allAssets.push(object);
    });

    console.log(allAssets);
  }
}

export default HandlesLoader;
